import React from "react";
import { useSelector } from "react-redux";
import useCartTotal from "./useCartTotal";
import { ref } from "yup";

const useTax = (deliveryType, opts = {}) => {
  const [amount] = useCartTotal();
  const selfPick = useSelector((x) => x.SelfPick);
  const { laundry_tax, laundry_free_delivery } =
    useSelector((s) => s.Config) || {};
  const { discountAmount = 0 } = useSelector((s) => s.Coupon) || {};
  const customer = useSelector((x) => x.Customer);

  const referralPercent = Number( opts?.referralPercent ?? customer?.referral_reward?.reward_amount ?? 0);
  const referralDiscountAmount = (amount * referralPercent) / 100;

  const deliveryChargeOverride =
  opts?.deliveryChargeOverride !== undefined && opts?.deliveryChargeOverride !== null
    ? Number(opts.deliveryChargeOverride)
    : null;

  // const referralDiscountAmount =
  // typeof opts?.referralDiscountAmount === "number"
  //   ? opts.referralDiscountAmount
  //   : (amount * referralPercent) / 100;

  // console.log(`customer use tax`, customer, );

  const [totals, setTotals] = React.useState({
    subtotal: 0,
    tax: 0,
    discount: 0,
    deliveryCharge: 0,
    referralDiscount: 0,
    total: 0,
    grossTotal: 0,
  });

  React.useEffect(() => {
    if (deliveryType && laundry_tax !== undefined) {
      // const grossTax = 1 + laundry_tax / 100;
      // const grossTotal = amount / grossTax;
      // const discount = discountAmount;
      // const subtotal = grossTotal - discount;
      // const tax = subtotal * (laundry_tax / 100);
      // const deliveryCharge =
      //   grossTotal >= laundry_free_delivery ? 0 : deliveryType.charge;
      // const total = subtotal + tax + deliveryCharge;

      const grossTotal = amount;
      const discount = discountAmount;
      const referralDiscount = referralDiscountAmount;
      const subtotal = grossTotal - discount - referralDiscount;
      const tax = subtotal * (laundry_tax / 100);
      let deliveryCharge =
        grossTotal >= laundry_free_delivery ? 0 : deliveryType.charge;
      if (selfPick === "false" || selfPick === false) {
        deliveryCharge = 0;
      }
      if (deliveryChargeOverride !== null && !Number.isNaN(deliveryChargeOverride)) {
        deliveryCharge = deliveryChargeOverride;
        if (selfPick === "false" || selfPick === false) {
          deliveryCharge = 0;
        }
      }
      const total = subtotal + tax + deliveryCharge;
      setTotals({ subtotal, tax, discount, referralDiscount, deliveryCharge, total, grossTotal });
    }
  }, [
    deliveryType,
    laundry_tax,
    laundry_free_delivery,
    discountAmount,
    referralDiscountAmount,
    amount,
    selfPick,
    deliveryChargeOverride,
  ]);

  const { subtotal, tax, discount, deliveryCharge, total, grossTotal, referralDiscount } = totals;

  return [subtotal, tax, discount, deliveryCharge, total, grossTotal, referralDiscount];
};

export default useTax;
